module.exports = __webpack_public_path__ + "img/search-file.503fa5d6.svg";